import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { TESTIMONIALS, PAGE_BANNERS } from "../data/content";

export default function Testimonials() {
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.clinic} alt="Testimonials" fallbackKey="clinic" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>Testimonials</h1>
          <div className="space-y-6">
            {TESTIMONIALS.map((t) => (
              <blockquote
                key={`${t.initials}-${t.text.slice(0, 40)}`}
                className="border-l-4 border-[#8da55f] bg-[#f6f8ec] pl-5 pr-4 py-4 italic relative"
              >
                <p className="leading-relaxed text-[#4a4a3d] not-italic">{t.text}</p>
                <footer className="mt-3 text-right font-display text-[#7d8e54]">— {t.initials}</footer>
              </blockquote>
            ))}
          </div>
        </article>
      </div>
    </div>
  );
}
